import React from 'react';

const UnifiedCard = ({
    status,
    name,
    subtitle,
    description,
    link,
    imageUrl,
    affiliateCode,
    linkLabel = 'Visit Site',
    className = '',
}) => {
    const cardContent = (
        <article
            className={`group flex-shrink-0 w-72 h-[420px] bg-white border border-[#E5DFD8] p-5 transition-colors hover:border-[#A68B6A] overflow-hidden flex flex-col ${className}`}
        >
            {/* Image */}
            {imageUrl && (
                <div className="h-36 mb-4 flex items-center justify-center flex-shrink-0">
                    <img
                        src={imageUrl}
                        alt={name}
                        className="w-full h-full object-contain"
                    />
                </div>
            )}

            {/* Content */}
            <div className="overflow-hidden flex-1">
                {status && (
                    <p
                        className="uppercase mb-2 text-[#A68B6A]"
                        style={{ fontSize: '0.65rem', letterSpacing: '0.15em' }}
                    >
                        {status}
                    </p>
                )}
                <h3
                    className="mb-1 text-[#2C2824] line-clamp-2"
                    style={{ fontFamily: "'Cinzel', serif", fontWeight: 400, fontSize: '1rem', letterSpacing: '0.04em' }}
                >
                    {name}
                </h3>
                {subtitle && (
                    <p className="text-[#8C8580] mb-2" style={{ fontSize: '0.85rem' }}>
                        {subtitle}
                    </p>
                )}
                {description && (
                    <p className="text-[#8C8580] line-clamp-4" style={{ fontSize: '0.8rem', lineHeight: 1.6 }}>
                        {description}
                    </p>
                )}
                {affiliateCode && (
                    <p className="mt-2 text-[#8C8580]" style={{ fontSize: '0.8rem' }}>
                        Use Code: <span className="text-[#A68B6A] font-bold">{affiliateCode}</span>
                    </p>
                )}
            </div>

            {/* Hover link indicator */}
            {link && (
                <div className="mt-auto pt-4 flex-shrink-0">
                    <p
                        className="text-[#A68B6A] opacity-0 group-hover:opacity-100 transition-opacity uppercase font-medium"
                        style={{ fontSize: '0.7rem', letterSpacing: '0.1em' }}
                    >
                        {linkLabel} →
                    </p>
                </div>
            )}
        </article>
    );

    if (link) {
        return (
            <a href={link} target="_blank" rel="noopener noreferrer" className="block">
                {cardContent}
            </a>
        );
    }

    return cardContent;
};

export default UnifiedCard;
